/* eslint-disable react/function-component-definition */
import React, { useImperativeHandle, useState } from 'react';
import Image from '$/components/NextImage';
import RoboneoModal from '$/components/Modal';
import Button from '$/components/base/Button';
import { useOfficialStore } from '$/store/useOfficialStore';
import useThemeStore from '$/store/useThemeStore';
import { useLanguageStore } from '$/store/languageStore';
import { getRoboneoPageUrl } from '$/utils/roboneoPageUrl';
import { VIP_MODAL_CHILD_Z_INDEX } from '../constants';
import styles from './index.module.scss';
import zfbIcon from './zfb.svg';

interface VipModalProps {
  qrcodeUrl: string;
  onClose: () => void;
  title?: string;

}
export interface QrcodeModalRef {
  openPayQrcode: () => void;
  closePayQrcode: () => void;
}

/**
 * 渲染独立支付二维码弹窗，并保持其层级高于订阅主弹窗。
 */
const PayQrodeModal: React.ForwardRefRenderFunction<QrcodeModalRef, VipModalProps> = (props, ref) => {
  const {
    qrcodeUrl, onClose, title = '',
  } = props;
  const [open, setOpen] = useState(false);
  const languageStore = useLanguageStore((state) => state.languageStore);
  const currentCountryCode = useOfficialStore((state) => state.currentCountryCode);
  const theme = useThemeStore((state) => state.theme);
  const handleClose = () => {
    onClose?.();
    setOpen(false);
  };
  useImperativeHandle(ref, () => ({
    openPayQrcode: () => {
      setOpen(true);
    },
    closePayQrcode: handleClose,
  }));

  return (
    <RoboneoModal
      zIndex={VIP_MODAL_CHILD_Z_INDEX}
      wrapClassName={styles['pay-qrcode-modal-wrapper']}
      open={open}
      onCancel={handleClose}
      bodyClassName={styles.qrcodeModalbody}
    >
      <div className={styles.title}>
        {title || languageStore.smartcatTranslationText((v) => v.subscribe_to_vip)}
      </div>
      <div className={styles['paycode-container']}>
        <div className={styles['paycode-content']}>
          <div className={styles['qrcode-cover']}>
            <Image alt="" src={qrcodeUrl} width={160} height={160} />
          </div>
          <div className={styles['pay-tip']}>
            <div className={styles['pay-tip-text']}>{ languageStore.smartcatTranslationText((v) => v.please_scan_the_qr_code_to_complete_payment)}</div>
            <Image alt="" src={zfbIcon} width={18} height={18} style={{ marginLeft: '4px' }} />
          </div>
        </div>
        <div>
          <div className={styles['no-text-decoration']}>
            <div>
              {languageStore.smartcatTranslationText((v) => v.roboneo_web_agreed)}
            </div>
            <Button
              type="transparent"
              className={styles['agree-service-agreement']}
              onClick={() => {
                // const searchParams = getUrlSearchParams();
                // const roomId = searchParams.get('room_id');
                // mtstatTrack('agreement_click', {
                //   room_id: roomId,
                // });
                // const { href } = window.location;
                // process.env.NEXT_PUBLIC_REBONEO_SERVER_URL
                // 协议pre
                window.open(getRoboneoPageUrl('/membership-pay-agreement', {
                  countryCode: currentCountryCode,
                  theme,
                }));
              }}
              buttonStyle={{ paddingLeft: '6px' }}
            >
              《
              {languageStore.smartcatTranslationText((v) => v.Robobeo_web_term_of_Service)}
              》
            </Button>

          </div>

        </div>
      </div>

    </RoboneoModal>
  );
};
export default React.forwardRef(PayQrodeModal);
